import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Athlete } from "@/models";
import { isEmpty } from "lodash";

const createAthlete = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "create",
    storeKey: "athlete",
    loadingKey: "athleteLoading",
    commitType: "mainAthleteWrappedMutation",
    message: "General Information Added",
    params
  });

const updateAthlete = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "update",
    storeKey: "athlete",
    loadingKey: "athleteLoading",
    commitType: "resourceObjectWrappedShow",
    message: params.message,
    params
  });

const updateAthleteTeamPlayed = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "updateAthleteTeamPlayed",
    storeKey: "athleteTeamPlayed",
    loadingKey: "athleteTeamPlayedLoading",
    commitType: "show",
    message: "Player updated",
    silent: true,
    params
  });

const updateAthleteImage = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "updateAthleteImages",
    storeKey: "athleteImages",
    loadingKey: "athleteLoading",
    commitType: "show",
    message: "uploaded",
    params
  });

const uploadScoutingImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "uploadScoutingImages",
    storeKey: "athleteImages",
    loadingKey: "athleteLoading",
    message: "Scouting Images Added to Profile",
    params
  });

const uploadAthleteImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "uploadAthleteImages",
    storeKey: "athleteImageUpload",
    loadingKey: "athleteImageUploadLoading",
    message: "Upload Complete",
    params
  });

const getAthlete = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "show",
    storeKey: "athlete",
    loadingKey: "athleteLoading",
    commitType: "show",
    params
  });

const getAthletes = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "index",
    storeKey: "athletes",
    loadingKey: "athletesLoading",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getAthletesForClubCoach = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "clubIndex",
    storeKey: "athletes",
    loadingKey: "athletesLoading",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getAthleteVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "getAthleteVideos",
    storeKey: "athleteVideos",
    loadingKey: "athleteVideosLoading",
    commitType: "indexUnwrapped",
    params
  });

const getAthleteEvents = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "getAthleteEvents",
    storeKey: "athleteEvents",
    loadingKey: "athleteEventsLoading",
    commitType: "randomObjectWrappedIndex",
    params
  });

const getProfileViews = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "getProfileViews",
    storeKey: "profileViews",
    loadingKey: "profileViewsLoading",
    commitType: "indexUnwrapped",
    metaKey: "profileViewMeta",
    params
  });

const deleteAthleteImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "deleteAthleteImages",
    storeKey: "deleteAthleteImages",
    loadingKey: "deleteAthleteImagesLoading",
    message: "Picture Deleted",
    params
  });

const updateBlockedGroup = (context, params) =>
  restApiDispatcher(context, {
    resource: Athlete,
    action: "updateBlockedGroup",
    storeKey: "athlete",
    commitType: "show",
    message: `${
      _.isEmpty(params.blockedGroup)
        ? "All Groups Unblocked"
        : `${
            params.blockedGroup.length === 2
              ? "All Coaches Blocked"
              : `${_.upperFirst(
                  _.snakeCase(params.blockedGroup[0])
                    .split("_")
                    .join(" ")
                )}es Blocked`
          }`
    }`,
    params
  });

const setFavourite = (context, athleteId) =>
  context.commit("SET_FAVOURITE", athleteId);

const unsetFavourite = (context, athleteId) =>
  context.commit("UNSET_FAVOURITE", athleteId);

const setFavouriteForInstitution = (context, institutionId) =>
  context.commit("SET_FAVOURITE_FOR_INSTITUTION", institutionId);

const unsetFavouriteForInstitution = (context, institutionId) =>
  context.commit("UNSET_FAVOURITE_FOR_INSTITUTION", institutionId);

const setAthleteFavourite = context => context.commit("SET_ATHLETE_FAVOURITE");

const unsetAthleteFavourite = context =>
  context.commit("UNSET_ATHLETE_FAVOURITE");

export default {
  getAthlete,
  getAthletes,
  setFavourite,
  unsetFavourite,
  getAthletesForClubCoach,
  getProfileViews,
  setFavouriteForInstitution,
  unsetFavouriteForInstitution,
  getAthleteVideos,
  getAthleteEvents,
  updateAthlete,
  createAthlete,
  updateAthleteImage,
  uploadAthleteImages,
  setAthleteFavourite,
  unsetAthleteFavourite,
  deleteAthleteImages,
  updateAthleteTeamPlayed,
  updateBlockedGroup,
  uploadScoutingImages
};
